<template>
    <button
        type="button"
        class="btn-prev"
        :disabled="internalDisabled"
        :aria-disabled="internalDisabled"
        @click.self.prevent
    >
        <pt-icon
            icon="pt-icon--back"
            :style="{
                width: '12px',
                height: '12px',
            }"
        ></pt-icon>
        <span v-if="prevText">{{ prevText }}</span>
    </button>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'Prev',
    props: {
        disabled: Boolean,
        currentPage: {
            type: Number,
            default: 1,
        },
        prevText: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const internalDisabled = computed(() => props.disabled || props.currentPage <= 1);
        return {
            internalDisabled,
        };
    },
});
</script>
